import { Route, Redirect } from "react-router-dom";
import { isLogged } from "../services/UserService";

const PrivateRoute = ({ component: Component, ...rest }: any) => {
	return (
		<Route {...rest} render={(props) => isLogged() ? <Component {...props} /> : <Redirect to="/" />} />
	);
};

export default PrivateRoute;